module.exports = __webpack_public_path__ + "img/featured_event.2e6b61e.webp";